export const DEFAULT_TTL = "00:01:00";
export const defaultTtl = (ttlStr) => {
  const raw = ttlStr || DEFAULT_TTL;
  const [h = 0, m = 0, s = 0] = String(raw).split(":").map(n => parseInt(n, 10) || 0);
  const total = h * 3600 + m * 60 + s;
  if (total < 60) return DEFAULT_TTL;
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
};